export const reducer = (state, action) => {
    switch (action.type) {
        case 'changeBik': {
            return {
                ...state,
                bik: action.payload,
            };
        }
        case 'changeName': {
            return {
                ...state,
                name: action.payload,
            };
        }
        case 'changePaymentAccount': {
            return {
                ...state,
                paymentAccount: action.payload,
            };
        }
        case 'changeShowConfirmationModal': {
            return {
                ...state,
                showConfirmationModal: action.payload,
            };
        }
    }
};
